import Component from '../core/Component'
import $ from 'jquery'
import Ps from 'perfect-scrollbar'
import { queries } from '../core/config';
import enquire from 'enquire.js'


$.nette.ext('snippet--survey', {
    success: function (payload) {
        if (payload.snippets) {
            if(payload.snippets['snippet--survey'] !== undefined) {
                var $scrollbar = $('#snippet--survey [data-component="Scrollbar"]')
                $scrollbar.scrollTop($scrollbar.height())
            }
        }
    }
});

export default class Scrollbar extends Component {
    constructor($element) {
        super($element)
    }

    prepare() {
        enquire.register(queries.xlargeUp,{
            match: () => {
                Ps.initialize(this.element, {
                    suppressScrollX: true,
                    scrollXMarginOffset: 40
                });
            }
        })
    }
}


// WEBPACK FOOTER //
// ./components/Scrollbar.js